import styled from 'styled-components';

const CardWrapper = styled.div`
	margin-top: 40px;
	padding: 20px;
	background-color: ${(props) => props.theme.palette.blocks.cardWrapper.background};
	box-shadow: 3px 3px 12px 0px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
`;

export default CardWrapper;
